import React from 'react';
import Header from '../components/Header';
import Teams from '../components/Teams';
import Jumbotron from '../components/Jumbotron';
import AssetClasses from '../components/AssetClasses';
import Leads from '../components/Leads';
import Cbp from '../components/Cbp';
import Testimonials from '../components/Testimonials';
import Faqs from '../components/Faqs';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <main>
      <section className='cbp_layout_header'>
        <div className='container-fluid grey-border-b-1'>
          <Header></Header>
        </div>
      </section>
      <section className='cbp_layout3'>
        <div className='container-fluid position-relative'>
          <Jumbotron></Jumbotron>
        </div>
      </section>
      <section className='cbp_layout-header'>
        <div className='container-fluid'>
          <Teams></Teams>
        </div>
      </section>
      <section className='cbp_layout'>
        <div className='container-fluid'>
          <AssetClasses></AssetClasses>
        </div>
      </section>
      <section className='cbp_layout'>
        <div className='container-fluid'>
          <Leads></Leads>
        </div>
      </section>
      <section className='cbp_layout'>
        <div className='container-fluid'>
          <Cbp></Cbp>
        </div>
      </section>
      <section className='cbp_layout'>
        <div className='container-fluid'>
          <Testimonials></Testimonials>
        </div>
      </section>
      <section className='cbp_layout'>
        <div className='container-fluid'>
          <Faqs showLimit={4}></Faqs>
        </div>
      </section>
      <section className='cbp_layout footer-section'>
        <div className='container'>
          <Footer></Footer>
        </div>
      </section>
      <div className='cbp_fixed_menu'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-12 d-flex p-0'>
              <Link to="/live-deals" className="cbp_fixed_btn cbp_fixed_btn1">
                <img src='/images/deals.svg' alt='home' /> <br />
                Live deals
              </Link>
              <Link to="/become-member" className="cbp_fixed_btn cbp_fixed_btn2">
                <img src='/images/become-mem.svg' alt='home' /> <br />
                Become a member
              </Link>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Home;